import * as pdfjsLib from 'pdfjs-dist'
import { updatePage } from '../actions/files'
import { LoadingPage, Page } from '../models/File'
import { Dispatch } from 'redux'
import { updatePermitPage } from '../actions/permit'
import store, { RootState } from '../store'
import { updateBuildingDocumentPage } from '../actions/construction'

type Reducer = (params: { fileId: string; page: LoadingPage }) => any

const reducers: { [key: string]: Reducer } = {
  updatePage: updatePage,
  updatePermitPage: updatePermitPage,
  updateBuildingDocumentPage: updateBuildingDocumentPage,
}

const findReducer = (fileId: string): Reducer | null => {
  const state = store.getState() as RootState
  if (!!state.drawings.files.find((file) => file.id === fileId)) {
    return reducers['updatePage']
  }

  if (state.permit.file?.id === fileId) {
    return reducers['updatePermitPage']
  }

  const structuralFiles = state.construction.documents?.map(
    (document) => document.file,
  )
  if (structuralFiles?.find((file) => file.id === fileId)) {
    return reducers['updateBuildingDocumentPage']
  }

  return null
}

export const pdfPagesNumber = (pdfData: any) => {
  return new Promise<number>((resolve, reject) => {
    const worker = new Worker(new URL('../workers/pdfWorker', import.meta.url))
    pdfjsLib.GlobalWorkerOptions.workerPort = worker
    worker.postMessage({ action: 'pagesNumber', pdfData })

    worker.onmessage = (event) => {
      if (event.data.error) {
        reject(new Error(event.data.error))
        worker.terminate()
      }
      if (event.data.pagesNumber) {
        const pagesNumber: number = event.data.pagesNumber
        resolve(pagesNumber)
        worker.terminate()
      }
    }

    worker.onerror = (error) => {
      reject(error)
      worker.terminate()
    }
  })
}

// TODO: transfer parameters to another place
export const pdfToImage = (
  fileId: string,
  pages: Page[],
  pdfData: string,
  dispatch: Dispatch,
  addCleanup?: (cleanup: () => void) => void,
) => {
  const worker = new Worker(new URL('../workers/pdfWorker', import.meta.url))
  pdfjsLib.GlobalWorkerOptions.workerPort = worker

  worker.postMessage({ action: 'pagesImages', pdfData })

  const terminateWorker = () => {
    worker.terminate()
  }

  if (addCleanup) {
    addCleanup(terminateWorker)
  }

  worker.onmessage = (event) => {
    if (event.data.error) {
      terminateWorker()
      throw new Error(event.data.error)
    }

    if (event.data.blob) {
      const pageNumber = event.data.pageNumber
      const blob: Blob = event.data.blob
      const imageUrl = URL.createObjectURL(blob)
      const reducer = findReducer(fileId)
      if (reducer) {
        const pageUpdate = {
          fileId: fileId,
          page: {
            id: pages[pageNumber - 1].id,
            number: pageNumber,
            image: imageUrl,
            isLoading: false,
          },
        }
        dispatch(reducer(pageUpdate))
      }
    }
    if (event.data.complete) {
      terminateWorker()
    }
  }

  worker.onerror = (error) => {
    terminateWorker()
    throw new Error(error.message)
  }
}
